import { render } from "./TransactionsHistory.vue?vue&type=template&id=30d55640&scoped=true"
import script from "./TransactionsHistory.vue?vue&type=script&lang=js"
export * from "./TransactionsHistory.vue?vue&type=script&lang=js"

import "./TransactionsHistory.vue?vue&type=style&index=0&id=30d55640&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d55640"]])

export default __exports__